import React from 'react';
import PropTypes from 'prop-types';
import TextInput from './text-input';
import {messagesShape} from '../messages';


export default class FullnameInput extends React.Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    value: PropTypes.string.isRequired,
    readOnly: PropTypes.bool.isRequired,
    editableByDefault: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    messages: messagesShape.isRequired
  };

  static defaultProps = {
    name: 'fullname',
    editableByDefault: true,
    readOnly: false,
    onChange: () => null,
    messages: [],
    value: ''
  };

  handleChange(value) {
    let [lastname, firstname] = value.split(/,/, 2);
    if (firstname) {
      firstname = firstname.replace(/^\s+/, '');
      if (firstname.length) {
        lastname = lastname && lastname.trim();
      }
      value = `${lastname}, ${firstname}`;
    }
    else {
      firstname = '';
    }
    value = value.replace(/^\s*,\s*$/, '');
    this.props.onChange({value, lastname, firstname});
  }

  render() {
    const {
      name, label, value,
      messages, readOnly, editableByDefault} = this.props;

    return (
      <TextInput
       {...{name, label, value, messages, readOnly, editableByDefault}}
       delimiter=", "
       placeholder={['Lastname', 'Firstname']}
       onChange={this.handleChange.bind(this)} />
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/fragments/forms/fullname-input.js